module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "profile"
  }, [_h('h1', {
    staticClass: "profile__name",
    domProps: {
      "textContent": _s(profile.name)
    }
  }), " ", _h('h2', {
    staticClass: "profile__screanname"
  }, [_h('a', {
    attrs: {
      "href": 'https://twitter.com/' + profile.screanname,
      "target": "_blank"
    }
  }, ["@", _h('span', {
    domProps: {
      "textContent": _s(profile.screanname)
    }
  })])]), " ", _h('p', {
    staticClass: "profile__bio",
    domProps: {
      "textContent": _s(profile.bio)
    }
  }), " ", _h('div', {
    staticClass: "profile__location"
  }, [_m(0), " ", _h('span', {
    domProps: {
      "textContent": _s(profile.location)
    }
  })]), " ", _h('div', {
    staticClass: "profile__birthday"
  }, [_m(1), " ", _h('span', [_s(_f("birthDay")(profile.birth))])]), " ", _h('div', {
    staticClass: "profile__url"
  }, [_h('ul', [_l((profile.urls), function(url) {
    return _h('li', [_m(2, true), " ", _h('a', {
      attrs: {
        "href": url.href,
        "target": "_blank"
      },
      domProps: {
        "textContent": _s(url.link)
      }
    })])
  })])]), " ", _h('div', {
    staticClass: "profile__certificates"
  }, [_h('ul', [_l((profile.remarks.certificates), function(certificate) {
    return _h('li', [_m(3, true), " ", _h('span', {
      domProps: {
        "textContent": _s(certificate.name)
      }
    })])
  })])])])
}},staticRenderFns: [function (){with(this) {
  return _h('i', {
    staticClass: "fa fa-map-marker"
  })
}},function (){with(this) {
  return _h('i', {
    staticClass: "fa fa-birthday-cake"
  })
}},function (){with(this) {
  return _h('i', {
    staticClass: "fa fa-link"
  })
}},function (){with(this) {
  return _h('i', {
    staticClass: "fa fa-ticket"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
 ** module id = 27
 ** module chunks = 1
 **/